import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import filterInvalidDOMProps from 'filter-invalid-dom-props';
import Content from '../../../internal/Content';
import Entry from '../Entry';
import Header from './Header';
var Title = styled.h1.withConfig({
  displayName: "Page__Title",
  componentId: "vhl45u-0"
})(["margin:", " auto;text-align:center;color:", ";font-size:2rem;text-transform:", ";line-height:1.2;max-width:90%;&.hidden{position:absolute;opacity:0;left:-99999999px;}@media screen and (min-width:600px){font-size:2.5rem;}@media screen and (min-width:800px){margin:", " auto;font-size:3rem;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mediumSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.textColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.largeSpacing;
});
var ContentWrapper = styled.div.withConfig({
  displayName: "Page__ContentWrapper",
  componentId: "vhl45u-1"
})(["margin:0 auto;margin-top:2em;max-width:760px;padding:0 20px;@media screen and (min-width:800px){margin-top:3em;}"]);

var PageTemplate =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(PageTemplate, _Component);

  function PageTemplate() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PageTemplate.prototype;

  _proto.render = function render() {
    return React.createElement(Entry, this.props);
  };

  return PageTemplate;
}(Component);

PageTemplate.Navigation = Entry.Navigation;
PageTemplate.Header = Entry.Header;

PageTemplate.Header = function (_ref5) {
  var node = _ref5.pageContext.node;
  return React.createElement(Header, {
    article: node
  });
};

PageTemplate.Navigation = function (_ref6) {
  var _ref6$pageContext = _ref6.pageContext,
      _ref6$pageContext$nod = _ref6$pageContext.node,
      translations = _ref6$pageContext$nod.translations,
      platforms = _ref6$pageContext$nod.platforms,
      menu = _ref6$pageContext$nod.menu,
      locale = _ref6$pageContext$nod.locale,
      shareUrls = _ref6$pageContext.shareUrls;
  return React.createElement(Entry.Navigation, {
    shareUrls: shareUrls,
    shareMessage: platforms && platforms.all && platforms.all.description,
    items: menu && menu.items,
    translations: translations,
    locale: locale
  });
};

PageTemplate.Title = function (_ref7) {
  var _ref7$pageContext = _ref7.pageContext,
      node = _ref7$pageContext.node,
      hidden = _ref7$pageContext.hidden,
      className = _ref7$pageContext.className,
      children = _ref7$pageContext.children,
      props = _objectWithoutPropertiesLoose(_ref7$pageContext, ["node", "hidden", "className", "children"]);

  return React.createElement(Title, Object.assign({}, filterInvalidDOMProps(props), {
    className: classNames(className, {
      hidden: hidden
    })
  }), node.title || children);
};

PageTemplate.Main = function (_ref8) {
  var node = _ref8.pageContext.node;
  return React.createElement(ContentWrapper, null, React.createElement(Content, {
    className: "mobiledoc-content",
    id: "entry-content",
    content: node.content
  }));
};

PageTemplate.defaultProps = {
  children: [React.createElement(PageTemplate.Navigation, null), React.createElement(PageTemplate.Header, null), React.createElement(PageTemplate.Main, null)]
};
export { PageTemplate as default };